export default ({ store, $axios, redirect, error }) => {
  // Rehydrate token from localStorage into store
  const token = localStorage.getItem('auth_token')
  if (token) {
    store.commit('authProfile/SET_TOKEN', token)
  }

  // Attach Bearer token to every outgoing request
  $axios.onRequest((config) => {
    const t = store.state.authProfile.token
    if (t) {
      config.headers.Authorization = `Bearer ${t}`
    }
    return config
  })

  // Handle 401 — clear auth state and send to login
  // Handle 403 — redirect to a forbidden/unauthorized page
  $axios.onResponseError((errorResponse) => {
    if (errorResponse.response?.status === 401) {
      store.dispatch('authProfile/reset')
      redirect('/auth/login')
    } else if (errorResponse.response?.status === 403) {
      error({
        statusCode: 403,
        message: 'ليس لديك صلاحية للوصول إلى هذا القسم'
      })
    }
    return Promise.reject(errorResponse)
  })
}
